"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ErrorIcon;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _svg;
function ErrorIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_material.SvgIcon, {
    className: className,
    viewBox: "0 0 3 9"
  }, _svg || (_svg = /*#__PURE__*/_react.default.createElement("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.41426 0.282128L2.22573 6.05786H0.854639L0.6604 0.282128H2.41426ZM0.614697 7.846C0.614697 7.60225 0.698486 7.40039 0.866065 7.24043C1.03745 7.07666 1.26216 6.99478 1.54019 6.99478C1.82202 6.99478 2.04673 7.07666 2.21431 7.24043C2.38188 7.40039 2.46567 7.60225 2.46567 7.846C2.46567 8.08213 2.38188 8.28208 2.21431 8.44585C2.04673 8.60962 1.82202 8.6915 1.54019 8.6915C1.26216 8.6915 1.03745 8.60962 0.866065 8.44585C0.698486 8.28208 0.614697 8.08213 0.614697 7.846Z",
    fill: "#ED1B2F"
  }))));
}